export enum OngletEnum {
  Projet,
  ModeValorisation,
  Raccordement,
  OptionsCapex,
  CapexTypePose,
  ParametresModulables,
  SimulationEnregistre,
  Zone1,
  Zone2,
  Zone3,
  Zone4,
  Zone5,
  Zone6
}
